import React from 'react'
import CurrencyFormat from "react-currency-format";
import {const_var } from "../../../redux/reducers/reducer";

function EndJTrimPrice() {

  const extraItems = const_var?.post_data?.building?.extra_items;
  const endJtrimPrice =  extraItems?.find(item => item.item_name === "End Jtrim");

  return (

    <div className='price-box-type-2'>   
      {((const_var.loginSession == false && const_var.hide_price_calculation != 1 && const_var.post_data.building!=undefined && const_var.post_data.building.extra_items.length>0 && endJtrimPrice!=undefined && endJtrimPrice.item_price>0)) &&
        <CurrencyFormat value = {endJtrimPrice.item_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
      }
    </div>
  )
}

export default EndJTrimPrice